import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgMinus24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Minus",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.25 12.75H4.75a.75.75 0 0 1 0-1.5h14.5a.75.75 0 0 1 0 1.5"
}));

export { SvgMinus24 as default };
//# sourceMappingURL=Minus24.js.map
